// extracted by mini-css-extract-plugin
module.exports = {"collapsible":"Collapsible_collapsible__Yusng","maxCharacterCount":"Collapsible_maxCharacterCount__9HTfL"};